<template>
    <div class="el-main-wrapper">
        <el-row class="el-title-block">
            <h1 class="el-title-with-icon">
                {{ $t('navigation.userGroups') }}
            </h1>
        </el-row>
        <div class="el-main-content" v-show="!showCreateOrEditUserGroupView">
            <stc-user-groups-list></stc-user-groups-list>
        </div>
        <div>
            <stc-dialog
                :title="userGroupCreateEditTitle"
                v-model="permissions.includes('USER_WRITE') && showCreateOrEditUserGroupView"
                @change="closeCreateBookingDialog"
            >
                <div class="el-main-content">
                    <stc-user-group-create
                        v-if="showCreateOrEditUserGroupView"
                        :schedules="schedules"
                        :gates="gates"
                    ></stc-user-group-create>
                    <div class="el-grid-card">
                        <stc-users-manage :key="componentKey" :usersOriginalFullList="usersOriginalFullList"></stc-users-manage>
                    </div>
                </div>
            </stc-dialog>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UserGroupCreate from '../../components/user-groups/UserGroupCreate'
import UsersManage from '../../components/user-groups/UsersManage'
import StcDialog from '../../components/Dialog'
import UserGroupsList from '../../components/user-groups/UserGroupsList'

export default {
    name: 'user-groups',

    components: {
        'stc-user-groups-list': UserGroupsList,
        'stc-user-group-create': UserGroupCreate,
        'stc-users-manage': UsersManage,
        'stc-dialog': StcDialog,
    },

    data() {
        return {
            showCreateOrEditUserGroupView: false,
            permissionsList: [],
            userGroupCreateEditTitle: '',
            schedules: [],
            gates: [],
            componentKey: 0,
            totalPages: 1,
            currentPage: 1,
            usersOriginalFullList: []
        }
    },

    created() {
        this.getAllUsers();
        Events.$on('update-user-create-edit-title', val => {
            if (val) {
                this.userGroupCreateEditTitle =
                    this.$t('form.title.create') +
                    ' ' +
                    this.$t('form.title.userGroup')
            } else {
                this.userGroupCreateEditTitle =
                    this.$t('form.title.update') +
                    ' ' +
                    this.$t('form.title.user')
            }
        })
        Events.$on('show-create-or-edit-group-view', val => {
            this.componentKey += 1
            this.showCreateOrEditUserGroupView = false
            this.showCreateOrEditUserGroupView = val
        })
    },

    beforeDestroy() {
        Events.$off('show-create-or-edit-group-view')
        Events.$off('update-user-create-edit-title')
    },

    computed: {
        ...mapGetters([
            'selectedContainer',
            'permissions',
            'containerTree',
            'containers',
        ]),
    },

    methods: {
        async getAllUsers() {
            const containerIdList = [this.selectedContainer.ContainerID]
            await this.getContainers(this.selectedContainer, containerIdList)
            let requestObj = {
                ContainerFilter: containerIdList,
                CurrentPage: 1,
                PageSize: 0,
            }
            let { data } = await this.$http.post(
                `/Container/User/Search`,
                requestObj
            )
            this.usersOriginalFullList = data.response
        },
        async getContainers(container, idList){
            if(container && container.Children.length === 0){
                return
            }else {
                for (const child of container.Children) {
                    idList.push(child.ContainerID)
                    this.getContainers(child, idList)
                }
            }
        },
        async closeCreateBookingDialog() {
            try {
                await this.$confirm(
                    this.$i18n.i18next.t('message.warning.resetUser', {
                        section: this.$i18n.i18next.t('text.user'),
                    }),
                    'Warning',
                    {
                        confirmButtonText: this.$i18n.i18next.t(
                            'button.text.confirm'
                        ),
                        cancelButtonText: this.$i18n.i18next.t(
                            'button.text.cancel'
                        ),
                        type: 'warning',
                    }
                )
                this.showCreateOrEditUserGroupView = false
                return true
            } catch (e) {
                return false
            }
        },
    },
}
</script>
